module.exports = __webpack_public_path__ + "static/service-shape2-f5bf7d423371f959afe8f0fc461ce07c.png";